import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Link from 'next/link';
import { categoriesType } from "../../constants/app";
import { CatMenuList, CatMenuListItem, SubCatMenuList, SubCatMenuListItem } from "./style";
var CategoryMenu = /*#__PURE__*/function (_Component) {
  function CategoryMenu() {
    var _this;
    _classCallCheck(this, CategoryMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _callSuper(this, CategoryMenu, [].concat(args)), _this.state = {
      selectedSubCategory: null
    }, _this.toggleSubCategory = function (e, categoryId) {
      e.stopPropagation();
      var selectedSubCategory = categoryId !== _this.state.selectedSubCategory ? categoryId : null;
      _this.setState({
        selectedSubCategory: selectedSubCategory
      });
    }, _assertThisInitialized(_this)));
  }
  _inherits(CategoryMenu, _Component);
  return _createClass(CategoryMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        categories = _this$props.categories,
        mobile = _this$props.mobile;
      var selectedSubCategory = this.state.selectedSubCategory;
      return __jsx(CatMenuList, null, __jsx(CatMenuListItem, {
        show: selectedSubCategory === null,
        highlight: true
      }, __jsx(Link, {
        href: "/all-stores"
      }, __jsx("a", {
        "data-final": true
      }, "All Stores A - Z"))), categories.map(function (_ref) {
        var categoryId = _ref.categoryId,
          displayName = _ref.displayName,
          subCategories = _ref.subCategories;
        var hasSubCategories = subCategories && subCategories.length > 0;
        var isSelected = categoryId === selectedSubCategory;
        // TODO: Remove offers-and-more from category list in dynamo
        // This check can be removed afterwards
        if (categoryId === 'offers-and-more') {
          return null;
        }
        return __jsx(CatMenuListItem, {
          key: categoryId,
          hasSubCategories: hasSubCategories,
          onClick: function onClick(e) {
            return _this2.toggleSubCategory(e, categoryId);
          },
          isSelected: isSelected,
          show: selectedSubCategory === null || isSelected,
          role: "button",
          "aria-pressed": isSelected,
          onKeyPress: function onKeyPress(e) {
            return _this2.toggleSubCategory(e, categoryId);
          }
        }, hasSubCategories && mobile ? __jsx("a", null, displayName) : __jsx(Link, {
          href: "/category?categoryId=".concat(categoryId),
          as: "/category/".concat(categoryId)
        }, __jsx("a", {
          "data-final": true
        }, displayName)), hasSubCategories && __jsx(SubCatMenuList, null, mobile && __jsx(SubCatMenuListItem, null, __jsx(Link, {
          href: "/category?categoryId=".concat(categoryId),
          as: "/category/".concat(categoryId)
        }, __jsx("a", {
          "data-final": true
        }, "All ".concat(displayName)))), subCategories.map(function (subCategory, i) {
          return __jsx(SubCatMenuListItem, {
            key: i
          }, __jsx(Link, {
            href: "/category?categoryId=".concat(categoryId, "&subCategoryId=").concat(subCategory.categoryId),
            as: "/category/".concat(categoryId, "/").concat(subCategory.categoryId)
          }, __jsx("a", {
            "data-final": true
          }, subCategory.displayName)));
        })));
      }), __jsx(CatMenuListItem, {
        show: selectedSubCategory === null,
        highlight: true
      }, __jsx(Link, {
        href: "/offers-and-more",
        as: "/category/offers-and-more"
      }, __jsx("a", {
        "data-final": true
      }, "Offers and more"))));
    }
  }]);
}(Component);
CategoryMenu.defaultProps = {
  categories: [],
  mobile: false
};
export default CategoryMenu;